import React from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import { trackEvent } from '../../lib/analytics';

const Footer: React.FC = () => {
  const handleLinkClick = (linkName: string) => {
    trackEvent('navigation', 'footer_link_click', linkName);
  };

  const handleEmailClick = () => {
    trackEvent('user_engagement', 'email_click', 'support_email');
  };

  return (
    <footer className="bg-neutral-100 text-neutral-700 py-8 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4">AI Pandit Ji</h3>
            <p className="text-sm text-neutral-600">
              Your AI-powered personal astrologer that provides accurate and insightful astrological readings based on your birth details.
            </p>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Support</h3>
            <div className="flex items-center text-sm text-neutral-600 mb-2">
              <Mail size={16} className="mr-2" />
              <a 
                href="mailto:theaipanditji@gmail.com" 
                className="hover:text-primary-600"
                onClick={handleEmailClick}
              >
                theaipanditji@gmail.com
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link 
                  to="/terms" 
                  className="hover:text-primary-600"
                  onClick={() => handleLinkClick('terms')}
                >
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link 
                  to="/privacy" 
                  className="hover:text-primary-600"
                  onClick={() => handleLinkClick('privacy')}
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link 
                  to="/shipping-returns" 
                  className="hover:text-primary-600"
                  onClick={() => handleLinkClick('shipping_returns')}
                >
                  Shipping & Returns
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-neutral-200 mt-8 pt-6 text-sm text-center text-neutral-500">
          © {new Date().getFullYear()} AI Pandit Ji. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;